import React from "react";
import ReactDOM from "react-dom";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";

const StatusCompletionComponent = () => {
  const statuses = [
    { label: "Completed", percentage: 10, color: "#008936" },
    { label: "Not Started", percentage: 20, color: "#0e8bfe" },
    { label: "In Progress", percentage: 30, color: "#f16136" },
    { label: "Hold", percentage: 20, color: "#ee940e" },
    { label: "Cancelled", percentage: 20, color: "#bc1203" },
  ];

  const width = 400;
  const height = 200;

  return (
    <div className="w-[424px] bg-white rounded-lg border border-gray-300 p-4">
      <h1 className="text-lg font-semibold text-gray-800 mb-4">All Task</h1>

      <div className="flex flex-col items-center mb-6">
        <PieChart width={width} height={height}>
          {/* Increased height for legend space */}
          <Pie
            data={statuses}
            cx={width / 2} // Center the pie horizontally
            cy={height / 2} // Center the pie vertically
            innerRadius={50}
            outerRadius={70}
            dataKey="percentage"
            paddingAngle={5}
            label={({ label, percentage }) => `${label}: ${percentage}%`}
          >
            {statuses.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <text
            x={width / 2} // Center text horizontally
            y={height / 2 + 6} // Center text vertically
            textAnchor="middle" // Center text alignment
            dominantBaseline="middle" // Center vertically relative to the baseline
            fontSize="12"
            fontWeight="bold"
            fill="#333"
          >
            All Tasks
          </text>
          <Tooltip />
          {/* <Legend
            layout="vertical"
            align="center"
            verticalAlign="bottom"
            wrapperStyle={{
              marginTop: 20, // Push the legend further down
            }}
            formatter={(value, entry) => entry.payload.label}
          /> */}
        </PieChart>
        <p className="mt-4 text-gray-700 text-lg font-medium">Overall Progress</p>
      </div>

      <div className="flex flex-col gap-4">
        {statuses.map((status, index) => (
          <div key={index} className="flex flex-col gap-2 text-sm font-medium">
            <div className="flex justify-between items-center">
              <span style={{ color: status.color }}>{status.label}</span>
              <span className="text-gray-600">{status.percentage}%</span>
            </div>
            <div className="relative w-full bg-gray-200 h-2 rounded">
              <div
                className="absolute top-0 left-0 h-2 rounded"
                style={{
                  width: `${status.percentage}%`,
                  backgroundColor: status.color,
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusCompletionComponent;
